import {
  ActionReducer,
  ActionReducerMap,
  createFeatureSelector,
  createSelector,
} from '@ngrx/store';
import { UserState, userReducer } from './reducer/userredinfo.reducer';


interface AppState {
  userState: UserState;
}
export const reducers: ActionReducerMap<AppState> = {
  userState: userReducer,
};
